import { render, staticRenderFns } from "./registro1p.vue?vue&type=template&id=4d26b7da&"
import script from "./registro1p.vue?vue&type=script&lang=js&"
export * from "./registro1p.vue?vue&type=script&lang=js&"
import style0 from "./registro1p.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports